module.exports = __webpack_public_path__ + "img/image1.c49b1158.png";